// PhoneInput component with (XXX) XXX-XXXX formatting

import { useState, useCallback } from 'react'

interface PhoneInputProps {
  value: string
  onChange: (value: string) => void
  id?: string
  name?: string
  placeholder?: string
  required?: boolean
  className?: string
}

// Format phone number as (XXX) XXX-XXXX
function formatPhoneNumber(value: string): string {
  // Remove all non-digits
  const digits = value.replace(/\D/g, '')

  // Limit to 10 digits
  const limited = digits.slice(0, 10)

  if (limited.length === 0) return ''
  if (limited.length <= 3) return `(${limited}`
  if (limited.length <= 6) return `(${limited.slice(0, 3)}) ${limited.slice(3)}`
  return `(${limited.slice(0, 3)}) ${limited.slice(3, 6)}-${limited.slice(6)}`
}

// Extract raw digits from formatted value
function extractDigits(value: string): string {
  return value.replace(/\D/g, '').slice(0, 10)
}

export function PhoneInput({
  value,
  onChange,
  id = 'phone',
  name = 'phone',
  placeholder = '(555) 555-5555',
  required = false,
  className = '',
}: PhoneInputProps) {
  const [displayValue, setDisplayValue] = useState(() => formatPhoneNumber(value))

  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value
    const digits = extractDigits(input)
    const formatted = formatPhoneNumber(digits)

    setDisplayValue(formatted)
    onChange(digits) // Return raw digits to parent
  }, [onChange])

  const handleFocus = useCallback((e: React.FocusEvent<HTMLInputElement>) => {
    // Move cursor to end on focus
    const len = e.target.value.length
    e.target.setSelectionRange(len, len)
  }, [])

  return (
    <input
      type="tel"
      id={id}
      name={name}
      value={displayValue}
      onChange={handleChange}
      onFocus={handleFocus}
      placeholder={placeholder}
      required={required}
      className={className}
      autoComplete="tel"
      maxLength={14} // (XXX) XXX-XXXX
    />
  )
}
